import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../actions/UsersActionsTableActions';
import * as columnFormatters from '../../../_common/column-formatters';
import * as customColumnFormatters from '../column-formatters';
import {useUsersActionsUIContext} from '../UsersActionsUIContext';
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from '../../../_common/components/CommonGrid';
import SortingColumnHeader from "../../../_common/components/SortingColumnHeader/SortingColumnHeader";

export default function UsersActionsTable() {
  const intl = useIntl();
  const prefix = 'users-actions-column';
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'username',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-username`, defaultMessage: 'User name'})}
          fieldName={'username'}
          useContext={useUsersActionsUIContext}
        />
    },
    {
      accessor: 'createTime',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-createTime`, defaultMessage: 'Created at'})}
          fieldName={'createTime'}
          useContext={useUsersActionsUIContext}
          showDefaultIcon={'createTime'}
        />
    },
    {
      accessor: 'source',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-source`, defaultMessage: 'Source'})}
          fieldName={'source'}
          useContext={useUsersActionsUIContext}
        />
    },
    {
      accessor: 'action',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-action`, defaultMessage: 'Action'})}
          fieldName={'action'}
          useContext={useUsersActionsUIContext}
        />
    },
    {
      accessor: 'relevantData',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-relevantData`, defaultMessage: 'Relevant data'})}
          fieldName={'relevantData'}
          useContext={useUsersActionsUIContext}
        />,
      width: 400,
    },
    {
      accessor: 'status',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
          fieldName={'status'}
          useContext={useUsersActionsUIContext}
        />
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      const username = [item?.responsibleUserFirstName, item?.responsibleUserLastName].filter(Boolean).join(' ');
      return {
        username: columnFormatters.BoldColumnFormatter(username),
        createTime: columnFormatters.DateColumnFormatter(item.createTime, true),
        source: customColumnFormatters.SourceTypeColumnFormatter(item),
        action: customColumnFormatters.ActionTypeColumnFormatter(item),
        relevantData: columnFormatters.ActionDataColumnFormatter(item),
        status: customColumnFormatters.StatusColumnFormatter(item),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'usersActionsTableReducer',
    UIContext: useUsersActionsUIContext(),
    getNewEntities: actions.getUsersActions,
    getNextEntities: actions.getNextUsersActions,
    onEntitiesChange: entities => {
      entities
        ? setTableRows(entities)
        : setTableRows([]);
    },
    dataLength: tableRows.length,
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      {...useTable({columns, data})}
    />
  );
}